/* eslint-disable @typescript-eslint/no-throw-literal */
import {
  action,
  observable,
} from 'mobx';
import {
  RequestStatus,
} from '../index';
import Connections from '../../connections';
import {
  BranchFeatureStoreInterface,
} from '../storeInterfaces/BranchFeatureInterface';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  BranchFeatureDTO,
} from '../../screens/branchFeaturesScreen/DTOs/branchFeatureDTO';
import {
  singleBranchFeatureById, branchFeaturesPath,
} from '../../axios/branchFeaturesRequests';

export class BranchFeatureStore implements BranchFeatureStoreInterface {
  @observable currentBranchFeature: BranchFeatureDTO;

  @observable BranchFeaturesList: BranchFeatureDTO[] = [];

  @observable CRUDStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getBranchFeaturesList(langCode: string): Promise<void> {
    try {
      this.CRUDStatus = RequestStatus.LOADING;

      const response = await Connections.wadiDeglaAxios.httpGet(branchFeaturesPath, getHeader(langCode));
      this.BranchFeaturesList = response?.data;

      this.CRUDStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.CRUDStatus = RequestStatus.FAILED;
      console.error(error);
      throw Promise.reject(error);
    }
  }

  @action
  public async getBranchFeatureById(featureId: number, langCode: string = DefaultLanguage): Promise<void> {
    try {
      this.CRUDStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(
        singleBranchFeatureById(featureId), getHeader(langCode),
      );

      this.currentBranchFeature = response?.data;

      this.CRUDStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.CRUDStatus = RequestStatus.FAILED;
      console.error(error);
      throw Promise.reject(error);
    }
  }

  @action
  public async createNewBranchFeature(
    branchFeature: BranchFeatureDTO, langCode: string = DefaultLanguage,
  ): Promise<number> {
    try {
      this.CRUDStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpPost(
        branchFeaturesPath, branchFeature, getHeader(langCode),
      );
      this.CRUDStatus = RequestStatus.SUCCESS;
      return response.data.newFeatureId;
    } catch (error) {
      this.CRUDStatus = RequestStatus.FAILED;
      console.error(error);
      return Promise.reject(error);
    }
  }

  @action
  public async updateBranchFeatureById(
    branchFeatureId: number, updatedBranchFeature: BranchFeatureDTO, langCode: string = DefaultLanguage,
  ): Promise<void> {
    try {
      await Connections.wadiDeglaAxios.httpPut(
        singleBranchFeatureById(branchFeatureId), {
          title: updatedBranchFeature.title,
          iconURL: updatedBranchFeature.iconURL,
        }, getHeader(langCode),
      );
      this.currentBranchFeature = updatedBranchFeature;
    } catch (error) {
      console.error(error);
      throw Promise.reject(error);
    }
  }
}
